import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { DateIntervalTimePickerComponent } from './date-interval-time-picker.component';
import {AngularMaterialModule} from "../../material-module";
import {MatSelectModule} from "@angular/material/select";

@NgModule({
  declarations: [DateIntervalTimePickerComponent],
    imports: [
        CommonModule,
        FormsModule,
        MatInputModule,
        AngularMaterialModule,
        MatSelectModule,
    ],
  exports: [DateIntervalTimePickerComponent]
})
export class DateIntervalTimePickerModule { }
